import { render, staticRenderFns } from "./completedHomeworkDetail.vue?vue&type=template&id=95da93a6&scoped=true"
import script from "./completedHomeworkDetail.vue?vue&type=script&lang=js"
export * from "./completedHomeworkDetail.vue?vue&type=script&lang=js"
import style0 from "./completedHomeworkDetail.vue?vue&type=style&index=0&id=95da93a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95da93a6",
  null
  
)

export default component.exports